import * as BABYLON from 'babylonjs';
import innerCubMaterial from '@/assets/images/three-dismensional/inner-cub.jpg';
import outterCubMaterial from '@/assets/images/three-dismensional/outter-cub.jpg';
import transCubMaterial from '@/assets/images/three-dismensional/trans-cub.jpg';
import ringCubMaterial from '@/assets/images/three-dismensional/ring-cub.png';
import Wall from '@/assets/images/three-dismensional/wall.jpg';
import GroundMa from '@/assets/images/three-dismensional/ground.jpg';

export default class Td {
  static createScene(canvas, engine = new BABYLON.Engine(canvas, true)) {
    // create the scene space
    const scene = new BABYLON.Scene(engine);
    scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    const camero = new BABYLON.ArcRotateCamera('Camera', -Math.PI / 4, Math.PI / 3, 120, BABYLON.Vector3.Zero(), scene);
    camero.attachControl(canvas, true);
    // all lights to the scene
    const light1 = new BABYLON.HemisphericLight('light1', new BABYLON.Vector3(0, 160, 0), scene);
    light1.intensity = 0.7;
    const light2 = new BABYLON.PointLight('light2', new BABYLON.Vector3(0, 100, 10), scene);
    light2.intensity = 0.1;
    const wallM = new BABYLON.StandardMaterial('wall', scene);
    wallM.diffuseTexture = new BABYLON.Texture(Wall, scene);
    wallM.diffuseTexture.hasAlpha = false;
    wallM.backFaceCulling = false;
    const wall0 = new BABYLON.MeshBuilder.CreatePlane('wall0', {
      width: 80,
      height: 10,
      frontUVs: new BABYLON.Vector4(0, 0.1, 0.6, 0),
      backUVs: new BABYLON.Vector4(0.2, 0.3, 0.4, 1),
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
      sourcePlane: new BABYLON.Plane(0, 0, 1, 40),
    }, scene);
    wall0.material = wallM;
    const wall1 = new BABYLON.MeshBuilder.CreatePlane('wall1', {
      width: 80,
      height: 10,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
      sourcePlane: new BABYLON.Plane(0, 0, 1, -40),
    }, scene);
    wall1.material = wallM;
    const wall2 = new BABYLON.MeshBuilder.CreatePlane('wall2', {
      width: 80,
      height: 10,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
      sourcePlane: new BABYLON.Plane(1, 0, 0, -40),
    }, scene);
    wall2.material = wallM;
    const wall3 = new BABYLON.MeshBuilder.CreatePlane('wall3', {
      width: 80,
      height: 10,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
      sourcePlane: new BABYLON.Plane(1, 0, 0, 40),
    }, scene);
    wall3.material = wallM;
    const groundM = new BABYLON.StandardMaterial('groundM', scene);
    groundM.diffuseTexture = new BABYLON.Texture(GroundMa, scene);
    groundM.diffuseTexture.hasAlpha = false;
    const ground = new BABYLON.MeshBuilder.CreatePlane('ground', {
      width: 80,
      height: 80,
      sideOrientation: BABYLON.Mesh.DOUBLESIDE,
      sourcePlane: new BABYLON.Plane(0, 10, 0, 0.5),
    }, scene);
    ground.material = groundM;
    // 变压器材质
    const transMaterial = new BABYLON.StandardMaterial('box', scene);
    transMaterial.diffuseTexture = new BABYLON.Texture(transCubMaterial, scene);
    transMaterial.diffuseTexture.hasAlpha = false;
    transMaterial.backFaceCulling = false;
    // 进线箱材质
    const innerMaterial = new BABYLON.StandardMaterial('box', scene);
    innerMaterial.diffuseTexture = new BABYLON.Texture(innerCubMaterial, scene);
    innerMaterial.diffuseTexture.hasAlpha = false;
    innerMaterial.backFaceCulling = false;
    // 出线箱材质
    const outterMaterial = new BABYLON.StandardMaterial('box', scene);
    outterMaterial.diffuseTexture = new BABYLON.Texture(outterCubMaterial, scene);
    outterMaterial.diffuseTexture.hasAlpha = false;
    outterMaterial.backFaceCulling = false;
    // 环网柜材质
    const ringMaterial = new BABYLON.StandardMaterial('box', scene);
    ringMaterial.diffuseTexture = new BABYLON.Texture(ringCubMaterial, scene);
    ringMaterial.diffuseTexture.hasAlpha = false;
    ringMaterial.backFaceCulling = false;
    // faceUV
    const columns = 6; // 6 columns
    const rows = 1; // 1 row

    // alien sprite
    const faceUV = new Array(6);

    // set all faces to same
    for (let i = 0; i < 6; i += 1) {
      faceUV[i] = new BABYLON.Vector4(i / columns, 0, (i + 1) / columns, 1 / rows);
    }

    // 左上
    const box0 = new BABYLON.MeshBuilder.CreateBox('box14', {
      height: 8,
      width: 8,
      depth: 6,
      faceUV,
    }, scene);
    box0.material = transMaterial;
    box0.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box0.position = new BABYLON.Vector3(0, -1, 25);
    const box1 = new BABYLON.MeshBuilder.CreateBox('box15', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box1.material = innerMaterial;
    box1.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box1.position = new BABYLON.Vector3(-6.1, -1, 24);
    const box2 = new BABYLON.MeshBuilder.CreateBox('box16', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box2.material = outterMaterial;
    box2.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box2.position = new BABYLON.Vector3(-10.2, -1, 24);
    const box3 = new BABYLON.MeshBuilder.CreateBox('box17', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box3.material = outterMaterial;
    box3.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box3.position = new BABYLON.Vector3(-14.3, -1, 24);
    const box4 = new BABYLON.MeshBuilder.CreateBox('box18', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box4.material = outterMaterial;
    box4.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box4.position = new BABYLON.Vector3(-18.4, -1, 24);
    // 左下
    const box5 = new BABYLON.MeshBuilder.CreateBox('box5', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box5.material = innerMaterial;
    box5.rotation = new BABYLON.Vector3(0, Math.PI / 2, 0);
    box5.position = new BABYLON.Vector3(-25, -1, -6);
    const box6 = new BABYLON.MeshBuilder.CreateBox('box6', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box6.material = outterMaterial;
    box6.rotation = new BABYLON.Vector3(0, Math.PI / 2, 0);
    box6.position = new BABYLON.Vector3(-25, -1, -1.9);
    const box7 = new BABYLON.MeshBuilder.CreateBox('box7', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box7.material = outterMaterial;
    box7.rotation = new BABYLON.Vector3(0, Math.PI / 2, 0);
    box7.position = new BABYLON.Vector3(-25, -1, 2.2);
    const box8 = new BABYLON.MeshBuilder.CreateBox('box8', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box8.material = outterMaterial;
    box8.rotation = new BABYLON.Vector3(0, Math.PI / 2, 0);
    box8.position = new BABYLON.Vector3(-25, -1, 6.3);
    const box19 = new BABYLON.MeshBuilder.CreateBox('box9', {
      height: 8,
      width: 8,
      depth: 6,
      faceUV,
    }, scene);
    box19.material = transMaterial;
    box19.position = new BABYLON.Vector3(-10, -1, -15);
    // 右下配电室配电柜
    const box9 = new BABYLON.MeshBuilder.CreateBox('box9', {
      height: 8,
      width: 8,
      depth: 6,
      faceUV,
    }, scene);
    box9.material = transMaterial;
    box9.position = new BABYLON.Vector3(20, -1, -25);
    box9.rotation = new BABYLON.Vector3(0, -1.56, 0);
    const box10 = new BABYLON.MeshBuilder.CreateBox('box10', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box10.material = innerMaterial;
    box10.rotation = new BABYLON.Vector3(0, -1.56, 0);
    box10.position = new BABYLON.Vector3(19, -1, -18.9);
    const box11 = new BABYLON.MeshBuilder.CreateBox('box11', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box11.material = outterMaterial;
    box11.rotation = new BABYLON.Vector3(0, -1.56, 0);
    box11.position = new BABYLON.Vector3(19, -1, -14.8);
    const box12 = new BABYLON.MeshBuilder.CreateBox('box12', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box12.material = outterMaterial;
    box12.rotation = new BABYLON.Vector3(0, -1.56, 0);
    box12.position = new BABYLON.Vector3(19, -1, -10.7);
    const box13 = new BABYLON.MeshBuilder.CreateBox('box13', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box13.material = outterMaterial;
    box13.rotation = new BABYLON.Vector3(0, -1.56, 0);
    box13.position = new BABYLON.Vector3(19, -1, -6.6);
    // 右上
    const box14 = new BABYLON.MeshBuilder.CreateBox('box14', {
      height: 8,
      width: 8,
      depth: 6,
      faceUV,
    }, scene);
    box14.material = transMaterial;
    box14.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box14.position = new BABYLON.Vector3(30, -1, 25);
    const box15 = new BABYLON.MeshBuilder.CreateBox('box15', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box15.material = innerMaterial;
    box15.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box15.position = new BABYLON.Vector3(23.9, -1, 24);
    const box16 = new BABYLON.MeshBuilder.CreateBox('box16', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box16.material = outterMaterial;
    box16.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box16.position = new BABYLON.Vector3(19.8, -1, 24);
    const box17 = new BABYLON.MeshBuilder.CreateBox('box17', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box17.material = outterMaterial;
    box17.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box17.position = new BABYLON.Vector3(15.7, -1, 24);
    const box18 = new BABYLON.MeshBuilder.CreateBox('box18', {
      height: 8,
      width: 4,
      depth: 4,
      faceUV,
    }, scene);
    box18.material = outterMaterial;
    box18.rotation = new BABYLON.Vector3(0, Math.PI, 0);
    box18.position = new BABYLON.Vector3(11.6, -1, 24);
    return scene;
  }
}
